import {
  createSlice,
  createAsyncThunk
} from '@reduxjs/toolkit'

import {
  getShopifyVisibleSites
} from '../services/shopifyProduct'

// 站点列表是 6 个 shopify 商品页共用的基础数据,收在 store 里避免每页各拉一遍
// 0827 起按当前用户归属渠道过滤(独立站权限隔离),弃单页/站点配置页仍用全量接口
export const getShopifySites = createAsyncThunk<any, void, any>(
  'shopifyProduct/sites',
  async () => {
    const data = await getShopifyVisibleSites()
    return data || []
  }
)

const shopifyProductSlice = createSlice({
  name: 'shopifyProduct',
  initialState: {
    sites: [],
    createDraft: null
  },
  reducers: {
    setCreateDraft(state, action) {
      state.createDraft = action.payload
    },
    clearCreateDraft(state) {
      state.createDraft = null
    }
  },
  extraReducers: {
    [getShopifySites.fulfilled as any]: (state, action) => {
      state.sites = action.payload
    },
    [getShopifySites.rejected as any]: (state) => {
      state.sites = []
    }
  }
})

const {
  actions,
  reducer
} = shopifyProductSlice

export const {
  setCreateDraft,
  clearCreateDraft
} = actions

export default reducer
